import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { apiService } from '../../../components/Config/api.service';
import { notify } from "../../../components/Utils/Notifications";
import Select from 'react-select';
import BasePrimeForm from "./BasePrimeForm";
import AmountInput from "../../../components/Utils/AmountInput";

const Avantages = ({ id, prime, setPrime, closeEdit }) => {
    const { t } = useTranslation();
    const [avantageTypes, setAvantageTypes] = useState([]);

    useEffect(() => {
        // Charger les types d'avantage depuis le backend
        apiService.getElement('/advantage_types').then(res => {
            setAvantageTypes(res.data.avantage_types);
        }).catch(() => {
            notify(t('primeAvantages.fetchError'), '', 3);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const avantageOptions = avantageTypes.map(opt => ({
        value: opt.id,
        label: opt.name,
        amount: opt.amount,
    }));

    const selectedAvantage = avantageOptions.find(opt => opt.value === prime.advantage_type) || null;

    const handleAvantageChange = (selectedOption) => {
        setPrime(prev => ({
            ...prev,
            advantage_type: selectedOption ? selectedOption.value : '',
            valeur: selectedOption ? selectedOption.amount : '',
            name: selectedOption ? selectedOption.label : '',
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPrime(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleMontantChange = (newValue) => {
        setPrime(p => ({ ...p, valeur: newValue }));
    };

    const onBeforeSave = (primeToSave) => {
        // Pour les avantages, on garde advantage_type au lieu de category
        // Pas besoin de modifier la catégorie car elle est fixe (BRUT) côté backend
    };

    return (
        <BasePrimeForm
            id={id}
            prime={prime}
            setPrime={setPrime}
            closeEdit={closeEdit}
            title={t('primeAvantages.title')}
            onBeforeSave={onBeforeSave}
            apiEndpoint="/advantage" // Spécifier l'endpoint pour les avantages
            type="advantage" // Indiquer le type pour adapter le comportement
        >
            <div className="form-control">
                <label className="label">
                    <span className="label-text">{t('primeAvantages.advantageType')}</span>
                </label>
                <Select
                    options={avantageOptions}
                    value={selectedAvantage}
                    onChange={handleAvantageChange}
                    isClearable
                    placeholder={t('primeAvantages.selectType')}
                    classNamePrefix="react-select"
                    className="react-select-container w-1/2"
                />
            </div>
            <div className="form-control">
                <label className="label">
                    <span className="label-text">{t('primeAvantages.position')}</span>
                </label>
                <input
                    type="text"
                    className="input input-bordered w-1/2"
                    placeholder={t('primeAvantages.position')}
                    name="position"
                    value={prime.position || ''}
                    onChange={handleChange}
                />
            </div>
            <div className="form-control">
                <label className="label">
                    <span className="label-text">{t('primeAvantages.amount')}</span>
                </label>
                <AmountInput
                    value={prime.valeur}
                    onChange={handleMontantChange}
                    className="input input-bordered w-1/2"
                    required
                />
            </div>
        </BasePrimeForm>
    );
}

export default Avantages;